<template>
  <container>
     <h1 style="font-size:25px;margin-bottom:30px;text-align:center">AR & TD</h1>
     
      <div style="margin-bottom:20px">
        <date-range-field v-model="rangeData"></date-range-field>
        <div>
          <span>Sort By : </span>
          <select v-model="sortBy"  name="sortBy" @change="sortByChangeHandle"  class="sortBySelect">
            <option value="Distance">Total Distance</option>
            <option value="Sessions"># of Sessions</option>                                
          </select>
        </div>
     </div>
    <div class="ar-td-table">
        <v-table
          :is-loading="loading"                
          :columns="columns"
          is-horizontal-resize
          style="width:100%;font-size:11px"
          :table-data="tableData"
          :show-vertical-border="true"
          :title-row-height ="30"
          :border="1"    
          :paging-index="(pageIndex)*pageSize"
          :footer="footer"  
          :footer-row-height="40"   
          :footer-cell-class-name="setFooterCellClass"    
        ></v-table>

        <div class="mt20 mb20 bold" style="padding-top:25px">
          <v-pagination @page-change="pageChange" @page-size-change="pageSizeChange" :total="pageTotal" :page-size="pageSize" :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']"></v-pagination>
      </div>


        </div>

  </container>
</template>
<script>
import Container from "@/components/Container"
import { mapActions, mapGetters } from "vuex"
import {VTable,VPagination} from 'vue-easytable'
import DateRangeField from '@/components/Forms/DateRangeField'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
export default {
  name: "tp",
  data() {
    return {

      columns: [
        // {field: "date", title:'Date', width: 100, titleAlign: 'center',columnAlign:'center', isFrozen: true,},
                {field: "rank", title:'Rank', width: 100, titleAlign: 'center',columnAlign:'center',
                 formatter: function (rowData,rowIndex,pagingIndex,field) {
                    var currentIndex = rowIndex+pagingIndex
                    return  currentIndex + 1
                  }
                },
                {field: "runnerName", title:'Runner Name', width: 250, titleAlign: 'center',columnAlign:'center',isResize:true},
                {field: "id", title:'Id', width: 120, titleAlign: 'center',columnAlign:'center',componentName:'runner-id',isResize:true},
                {field: "gender", title:'Sex', width: 100, titleAlign: 'center',columnAlign:'center', },
                {field: "Sessions", title:'# of Sessions', width: 250, titleAlign: 'center',columnAlign:'center',},
                {field: "Distance", title:'Distance(KM)', width: 250, titleAlign: 'center',columnAlign:'center',},
                
      ],
      tableData :[],
      footer:[[]],
      pageIndex:0,
      pageTotal:null,
      pageSize:10,       
      rangeData:{
        startDate: moment().startOf('month').startOf('day').toISOString(),
        endDate:  moment().endOf('month').endOf('day').toISOString(),
      },
      loading:false,
      sortBy:'Distance'
            
    }
  },
  computed: {
  },
  methods: {
    intialize(){
      this.getTotalDistance(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize,this.sortBy)   
    },
    getTotalDistance(startDate,endDate,pageIndex,pageSize,sortBy){
    //add one day more to get acurate filter
    //var newEndate = moment(endDate, "YYYY-MM-DD").add('days', 1).format('YYYY-MM-DD')
    this.loading=true
    const AuthStr = 'Bearer '.concat(window.localStorage.getItem('default-auth-token'))
    //axios.get(`http://localhost:3007/getTotalDistance?startDate=`+startDate+`&endDate=` + endDate +`&pageIndex=`+pageIndex+`&pageSize=`+pageSize+`&orderBy=`+sortBy+`&staging=`+this.$isStage, { headers: { Authorization: AuthStr } })
    axios.get(this.$expressApi+`getTotalDistance?startDate=`+startDate+`&endDate=` + endDate +`&pageIndex=`+pageIndex+`&pageSize=`+pageSize+`&orderBy=`+sortBy+`&staging=`+this.$isStage, { headers: { Authorization: AuthStr } })
            .then(response => {  
              console.log("resp----",response.data)
              this.tableData=response.data.content
              this.pageTotal = response.data.totalElements
              if(this.tableData.length>0){
                this.footer=[['Total','','','',response.data.totalSessions,response.data.totalDistance]]
              }else{
                this.footer=[]
              }
              this.loading=false
          },error=>{
              this.tableData=[],
              this.footer=[]
              console.log("error",error)
              this.loading=false
          })
    },
    pageChange(pageIndex){
      this.pageIndex = pageIndex-1
      this.getTotalDistance(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize,this.sortBy)        
    },
     pageSizeChange(pageSize){
      this.pageIndex = 0
      this.pageSize = pageSize
      this.getTotalDistance(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex, this.pageSize,this.sortBy)        
    },  
    setFooterCellClass(rowIndex, colIndex, value){
      if (colIndex === 0) {
          return 'footer-cell-class-name-title'
      } else {
       return 'footer-cell-class-name-normal'
      }
    },
    sortByChangeHandle(evt){
      this.getTotalDistance(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex, this.pageSize,this.sortBy)        
    }  
  },
  created() {
    this.intialize()
  },
  watch: {
     rangeData(oldVal, newVal) {
            this.pageIndex = 0
            this.pageSize= 10
            this.intialize()
            //console.log(oldVal,"---newVal---",newVal)            
            //console.log(this.rangeData.startDate,this.rangeData.endDate,this.pageIndex,this.pageSize)
        }
  },
  components: {
    Container,
    DateRangeField
  }
}

Vue.component('runner-id',{
        template:`<span>
        <a href="" @click.stop.prevent="runnerData()">{{rowData.id}}</a>&nbsp
        </span>`,
        data: () => ({
        //   id:null 
        }),
        props:{
            rowData:{
                type:Object
            },
            field:{
                type:String
            },
            index:{
                type:Number
            }
        },
        methods:{
          runnerData(){
              let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: this.rowData.id
                        }
                    })
              window.open(route.href, '_blank')
          }
        },
        created() { 
        }
})
</script>

<style>
.ar-td-table tr.v-table-header-row {
    background: #423799;
    color: white;
    font-size: 12px;
    font-weight: bold;
}
.sortBySelect{
  padding: 4px 15px 4px 15px;
  font-size: 15px;
  background-color: #fff;
}

.daterangepicker.show-calendar .ranges{
  float:left
}




</style>



// WEBPACK FOOTER //
// AR&TD.vue?984dcf1a